import { API } from "../auth/authApi";

export const uploadBulkUsersApi = (data) => {
    return API.post("/bulk/user/upload", data, {
        headers: { "Content-Type": "multipart/form-data" },
    });
};